module.exports = "//cdn.mxpnl.com/static/asset-cache/d7e4c817300ea8000ffdeaedb4796f48/iron/common/widgets/warning-hero/images/empty-lexicon.svg";